export const RoomStatusTypes = {
    "0": "",
    "1": "clean",
    "2": "dirty",
    "3": "inspection"
}

export const MaintenanceStatusTypes = {
    "1": "Out Of Service",
    "2": "Out Of Order"
}